import React, { useContext } from 'react';

import { Redirection } from '@confluence/route-manager/entry-points/Redirection';
import { CONTEXT_PATH, SPACE_OVERVIEW } from '@confluence/named-routes';
import { SPAViewContext } from '@confluence/spa-view-context';

const CUSTOM_HOMEPAGE_QUERY_PARAMS = { mode: 'global' };

type SiteHomepageRedirectProps = {
	children?: React.ReactNode;
};

export const SiteHomepageRedirect = ({ children }: SiteHomepageRedirectProps) => {
	const { homepageUri, loading, error } = useContext(SPAViewContext);

	if (loading) {
		return null;
	}

	if (!error) {
		const matchedRoute = SPACE_OVERVIEW.match(`${CONTEXT_PATH}${homepageUri}`);
		if (matchedRoute) {
			return (
				<Redirection
					name={SPACE_OVERVIEW.name}
					params={{
						...matchedRoute.params,
						query: CUSTOM_HOMEPAGE_QUERY_PARAMS,
					}}
				/>
			);
		}
	}

	return <>{children}</>;
};
